import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, FilterIcon, DownloadIcon, EyeIcon, EditIcon, TrashIcon, UsersIcon, BuildingIcon, ArrowUpRightIcon, BarChart2Icon, SearchIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
import Modal from '../../components/ui/Modal';
import ExportMenu from '../../components/ui/ExportMenu';
// Mock Super Merchant data
const superMerchantsData = [{
  id: 'SM001',
  name: 'Global Retail Group',
  businessType: 'Retail Conglomerate',
  taxId: 'TX-1234567',
  status: 'active',
  paymentMethods: ['POS', 'QR', 'Online', 'NFC'],
  transactionVolume: 1250000,
  merchantCount: 8,
  lastActivity: '2023-07-15T10:30:00Z',
  contactPerson: 'John Smith',
  email: 'john@globalretail.com',
  phone: '+1 (555) 123-4567'
}, {
  id: 'SM002',
  name: 'Fast Food Alliance',
  businessType: 'Food & Beverage',
  taxId: 'TX-7654321',
  status: 'active',
  paymentMethods: ['POS', 'QR', 'Online'],
  transactionVolume: 980000,
  merchantCount: 12,
  lastActivity: '2023-07-16T14:45:00Z',
  contactPerson: 'Sarah Johnson',
  email: 'sarah@fastfoodalliance.com',
  phone: '+1 (555) 987-6543'
}, {
  id: 'SM003',
  name: 'Tech Distribution Network',
  businessType: 'Technology',
  taxId: 'TX-9876543',
  status: 'inactive',
  paymentMethods: ['Online', 'QR'],
  transactionVolume: 450000,
  merchantCount: 5,
  lastActivity: '2023-06-30T09:15:00Z',
  contactPerson: 'Michael Chen',
  email: 'michael@techdistribution.com',
  phone: '+1 (555) 456-7890'
}, {
  id: 'SM004',
  name: 'Hospitality Group International',
  businessType: 'Hospitality',
  taxId: 'TX-5432198',
  status: 'active',
  paymentMethods: ['POS', 'QR', 'Online', 'NFC', 'RTP'],
  transactionVolume: 2100000,
  merchantCount: 15,
  lastActivity: '2023-07-17T11:20:00Z',
  contactPerson: 'Emma Rodriguez',
  email: 'emma@hospitalitygroup.com',
  phone: '+1 (555) 234-5678'
}, {
  id: 'SM005',
  name: 'Urban Transport Consortium',
  businessType: 'Transportation',
  taxId: 'TX-8765432',
  status: 'pending',
  paymentMethods: ['QR', 'NFC'],
  transactionVolume: 750000,
  merchantCount: 3,
  lastActivity: '2023-07-10T16:40:00Z',
  contactPerson: 'David Wilson',
  email: 'david@urbantransport.com',
  phone: '+1 (555) 876-5432'
}];
// Mock subordinate merchants data
const subordinateMerchantsData = {
  SM001: [{
    id: 'CM001',
    name: 'CityMart Stores',
    type: 'Chain Merchant',
    status: 'active',
    storeCount: 24,
    transactionVolume: 520000,
    lastActivity: '2023-07-15T09:30:00Z'
  }, {
    id: 'CM002',
    name: 'HomeGoods Plus',
    type: 'Chain Merchant',
    status: 'active',
    storeCount: 15,
    transactionVolume: 480000,
    lastActivity: '2023-07-14T15:45:00Z'
  }, {
    id: 'IM001',
    name: 'Downtown Electronics',
    type: 'Individual Merchant',
    status: 'active',
    storeCount: 1,
    transactionVolume: 125000,
    lastActivity: '2023-07-16T10:20:00Z'
  }, {
    id: 'IM002',
    name: 'Fashion Forward',
    type: 'Individual Merchant',
    status: 'inactive',
    storeCount: 1,
    transactionVolume: 85000,
    lastActivity: '2023-07-10T14:15:00Z'
  }],
  SM002: [{
    id: 'CM003',
    name: 'Quick Burger Chain',
    type: 'Chain Merchant',
    status: 'active',
    storeCount: 32,
    transactionVolume: 620000,
    lastActivity: '2023-07-16T12:30:00Z'
  }, {
    id: 'CM004',
    name: 'Fresh Salad Bars',
    type: 'Chain Merchant',
    status: 'active',
    storeCount: 18,
    transactionVolume: 240000,
    lastActivity: '2023-07-15T11:45:00Z'
  }, {
    id: 'IM003',
    name: 'Gourmet Coffee Shop',
    type: 'Individual Merchant',
    status: 'active',
    storeCount: 1,
    transactionVolume: 75000,
    lastActivity: '2023-07-16T08:20:00Z'
  }],
  SM003: [{
    id: 'CM005',
    name: 'Gadget World',
    type: 'Chain Merchant',
    status: 'inactive',
    storeCount: 8,
    transactionVolume: 320000,
    lastActivity: '2023-06-28T14:30:00Z'
  }, {
    id: 'IM004',
    name: 'Premium Phones',
    type: 'Individual Merchant',
    status: 'active',
    storeCount: 1,
    transactionVolume: 95000,
    lastActivity: '2023-07-05T10:15:00Z'
  }],
  SM004: [{
    id: 'CM006',
    name: 'Luxury Hotels',
    type: 'Chain Merchant',
    status: 'active',
    storeCount: 12,
    transactionVolume: 1400000,
    lastActivity: '2023-07-17T09:30:00Z'
  }, {
    id: 'CM007',
    name: 'Budget Inns',
    type: 'Chain Merchant',
    status: 'active',
    storeCount: 28,
    transactionVolume: 580000,
    lastActivity: '2023-07-16T16:45:00Z'
  }, {
    id: 'IM005',
    name: 'Seaside Resort',
    type: 'Individual Merchant',
    status: 'active',
    storeCount: 1,
    transactionVolume: 120000,
    lastActivity: '2023-07-15T12:20:00Z'
  }],
  SM005: [{
    id: 'CM008',
    name: 'City Cab Services',
    type: 'Chain Merchant',
    status: 'pending',
    storeCount: 1,
    transactionVolume: 450000,
    lastActivity: '2023-07-10T15:30:00Z'
  }, {
    id: 'IM006',
    name: 'Airport Shuttle',
    type: 'Individual Merchant',
    status: 'active',
    storeCount: 1,
    transactionVolume: 180000,
    lastActivity: '2023-07-12T11:15:00Z'
  }, {
    id: 'IM007',
    name: 'Luxury Car Rental',
    type: 'Individual Merchant',
    status: 'pending',
    storeCount: 1,
    transactionVolume: 120000,
    lastActivity: '2023-07-08T14:20:00Z'
  }]
};
interface SuperMerchant {
  id: string;
  name: string;
  businessType: string;
  taxId: string;
  status: string;
  paymentMethods: string[];
  transactionVolume: number;
  merchantCount: number;
  lastActivity: string;
  contactPerson: string;
  email: string;
  phone: string;
}
interface SubordinateMerchant {
  id: string;
  name: string;
  type: string;
  status: string;
  storeCount: number;
  transactionVolume: number;
  lastActivity: string;
}
const AggregatorManagement: React.FC = () => {
  const navigate = useNavigate();
  const [superMerchants, setSuperMerchants] = useState<SuperMerchant[]>(superMerchantsData);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedSuperMerchant, setSelectedSuperMerchant] = useState<SuperMerchant | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Form state for add/edit modal
  const [formData, setFormData] = useState<Partial<SuperMerchant>>({
    name: '',
    businessType: '',
    taxId: '',
    status: 'active',
    paymentMethods: [],
    contactPerson: '',
    email: '',
    phone: ''
  });
  const handleAddSuperMerchant = () => {
    setIsEditing(false);
    setFormData({
      name: '',
      businessType: '',
      taxId: '',
      status: 'active',
      paymentMethods: [],
      contactPerson: '',
      email: '',
      phone: ''
    });
    setShowAddEditModal(true);
  };
  const handleEditSuperMerchant = (merchant: SuperMerchant) => {
    setIsEditing(true);
    setFormData({
      ...merchant
    });
    setShowAddEditModal(true);
  };
  const handleDeleteSuperMerchant = (merchant: SuperMerchant) => {
    setSelectedSuperMerchant(merchant);
    setShowDeleteModal(true);
  };
  const handleViewSuperMerchant = (merchant: SuperMerchant) => {
    setSelectedSuperMerchant(merchant);
    setShowViewModal(true);
  };
  const handleViewSubordinateMerchants = (merchantId: string, merchantType: string) => {
    if (merchantType === 'Chain Merchant') {
      navigate(`/chain-merchants?id=${merchantId}`);
    } else {
      navigate(`/individual-merchant?id=${merchantId}`);
    }
  };
  const confirmDelete = () => {
    if (selectedSuperMerchant) {
      setSuperMerchants(superMerchants.filter(m => m.id !== selectedSuperMerchant.id));
      setShowDeleteModal(false);
      setSelectedSuperMerchant(null);
    }
  };
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handlePaymentMethodChange = (method: string) => {
    setFormData(prev => {
      const currentMethods = prev.paymentMethods || [];
      if (currentMethods.includes(method)) {
        return {
          ...prev,
          paymentMethods: currentMethods.filter(m => m !== method)
        };
      } else {
        return {
          ...prev,
          paymentMethods: [...currentMethods, method]
        };
      }
    });
  };
  const handleSubmitForm = () => {
    if (isEditing && selectedSuperMerchant) {
      // Update existing super merchant
      setSuperMerchants(superMerchants.map(m => m.id === selectedSuperMerchant.id ? {
        ...m,
        ...formData,
        // Keep these fields as they are
        transactionVolume: m.transactionVolume,
        merchantCount: m.merchantCount,
        lastActivity: m.lastActivity
      } : m));
    } else {
      // Add new super merchant
      const newSuperMerchant: SuperMerchant = {
        id: `SM${String(superMerchants.length + 1).padStart(3, '0')}`,
        name: formData.name || '',
        businessType: formData.businessType || '',
        taxId: formData.taxId || '',
        status: formData.status || 'active',
        paymentMethods: formData.paymentMethods || [],
        transactionVolume: 0,
        merchantCount: 0,
        lastActivity: new Date().toISOString(),
        contactPerson: formData.contactPerson || '',
        email: formData.email || '',
        phone: formData.phone || ''
      };
      setSuperMerchants([...superMerchants, newSuperMerchant]);
    }
    setShowAddEditModal(false);
  };
  const handleExport = (format: 'csv' | 'xlsx' | 'pdf') => {
    console.log(`Exporting super merchants as ${format}`);
    // Implementation for export functionality would go here
  };
  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <StatusBadge status="success" text="Active" data-id="element-779" />;
      case 'inactive':
        return <StatusBadge status="danger" text="Inactive" data-id="element-780" />;
      case 'pending':
        return <StatusBadge status="warning" text="Pending" data-id="element-781" />;
      default:
        return <StatusBadge status="default" text={status} data-id="element-782" />;
    }
  };
  const columns = [{
    header: 'Super Merchant',
    accessor: (merchant: SuperMerchant) => <div data-id="element-783">
          <div className="font-medium" data-id="element-784">{merchant.name}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-785">
            {merchant.id}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Business Type',
    accessor: 'businessType',
    sortable: true
  }, {
    header: 'Status',
    accessor: (merchant: SuperMerchant) => getStatusBadge(merchant.status),
    sortable: false
  }, {
    header: 'Merchant Count',
    accessor: 'merchantCount',
    sortable: true
  }, {
    header: 'Transaction Volume',
    accessor: (merchant: SuperMerchant) => formatCurrency(merchant.transactionVolume),
    sortable: true
  }, {
    header: 'Last Activity',
    accessor: (merchant: SuperMerchant) => formatDateTime(merchant.lastActivity),
    sortable: true
  }];
  const filteredSuperMerchants = superMerchants.filter(merchant => merchant.name.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.id.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.businessType.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-786">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-787">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-788">
          Aggregator Management
        </h1>
        <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-789">
          <button onClick={() => setShowFilters(!showFilters)} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-790">
            <FilterIcon className="h-4 w-4 mr-2" data-id="element-791" />
            Filters
          </button>
          <ExportMenu onExport={handleExport} data-id="element-792" />
          <button onClick={handleAddSuperMerchant} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-793">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-794" />
            Add Super Merchant
          </button>
        </div>
      </div>

      {/* Dashboard Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-795">
        <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-800" data-id="element-796">
          <div className="flex items-center" data-id="element-797">
            <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-800 mr-4" data-id="element-798">
              <BuildingIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" data-id="element-799" />
            </div>
            <div data-id="element-800">
              <p className="text-sm font-medium text-blue-600 dark:text-blue-400" data-id="element-801">
                Super Merchants
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-802">
                {superMerchants.length}
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-green-50 dark:bg-green-900/20 border-green-100 dark:border-green-800" data-id="element-803">
          <div className="flex items-center" data-id="element-804">
            <div className="p-3 rounded-full bg-green-100 dark:bg-green-800 mr-4" data-id="element-805">
              <UsersIcon className="h-6 w-6 text-green-600 dark:text-green-400" data-id="element-806" />
            </div>
            <div data-id="element-807">
              <p className="text-sm font-medium text-green-600 dark:text-green-400" data-id="element-808">
                Total Merchants
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-809">
                {superMerchants.reduce((sum, merchant) => sum + merchant.merchantCount, 0)}
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-purple-50 dark:bg-purple-900/20 border-purple-100 dark:border-purple-800" data-id="element-810">
          <div className="flex items-center" data-id="element-811">
            <div className="p-3 rounded-full bg-purple-100 dark:bg-purple-800 mr-4" data-id="element-812">
              <BarChart2Icon className="h-6 w-6 text-purple-600 dark:text-purple-400" data-id="element-813" />
            </div>
            <div data-id="element-814">
              <p className="text-sm font-medium text-purple-600 dark:text-purple-400" data-id="element-815">
                Transaction Volume
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-816">
                {formatCurrency(superMerchants.reduce((sum, merchant) => sum + merchant.transactionVolume, 0))}
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-amber-50 dark:bg-amber-900/20 border-amber-100 dark:border-amber-800" data-id="element-817">
          <div className="flex items-center" data-id="element-818">
            <div className="p-3 rounded-full bg-amber-100 dark:bg-amber-800 mr-4" data-id="element-819">
              <ArrowUpRightIcon className="h-6 w-6 text-amber-600 dark:text-amber-400" data-id="element-820" />
            </div>
            <div data-id="element-821">
              <p className="text-sm font-medium text-amber-600 dark:text-amber-400" data-id="element-822">
                Active Merchants
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-823">
                {superMerchants.filter(m => m.status === 'active').length}
              </p>
            </div>
          </div>
        </Card>
      </div>

      {/* Search and Filters */}
      <div className="flex flex-col md:flex-row gap-4" data-id="element-824">
        <div className="relative flex-grow" data-id="element-825">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-826">
            <SearchIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-827" />
          </div>
          <input type="text" className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm rounded-md block w-full pl-10 p-2.5" placeholder="Search by name, ID, or business type" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-828" />
        </div>
      </div>

      {showFilters && <Card data-id="element-829">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-830">
            <div data-id="element-831">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-832">
                Status
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-833">
                <option value="" data-id="element-834">All Statuses</option>
                <option value="active" data-id="element-835">Active</option>
                <option value="inactive" data-id="element-836">Inactive</option>
                <option value="pending" data-id="element-837">Pending</option>
              </select>
            </div>
            <div data-id="element-838">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-839">
                Business Type
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-840">
                <option value="" data-id="element-841">All Types</option>
                <option value="Retail Conglomerate" data-id="element-842">Retail Conglomerate</option>
                <option value="Food & Beverage" data-id="element-843">Food & Beverage</option>
                <option value="Technology" data-id="element-844">Technology</option>
                <option value="Hospitality" data-id="element-845">Hospitality</option>
                <option value="Transportation" data-id="element-846">Transportation</option>
              </select>
            </div>
            <div data-id="element-847">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-848">
                Merchant Count
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-849">
                <option value="" data-id="element-850">All</option>
                <option value="1-5" data-id="element-851">1-5 merchants</option>
                <option value="6-10" data-id="element-852">6-10 merchants</option>
                <option value="11-20" data-id="element-853">11-20 merchants</option>
                <option value="20+" data-id="element-854">20+ merchants</option>
              </select>
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-3" data-id="element-855">
            <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-856">
              Reset
            </button>
            <button className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-857">
              Apply Filters
            </button>
          </div>
        </Card>}

      <Card data-id="element-858">
        <Table columns={columns} data={filteredSuperMerchants} keyField="id" actions={merchant => <div className="flex justify-end space-x-2" data-id="element-860">
              <button onClick={() => handleViewSuperMerchant(merchant)} className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View" data-id="element-861">
                <EyeIcon className="h-5 w-5" data-id="element-862" />
              </button>
              <button onClick={() => handleEditSuperMerchant(merchant)} className="p-1 rounded-full text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30" title="Edit" data-id="element-863">
                <EditIcon className="h-5 w-5" data-id="element-864" />
              </button>
              <button onClick={() => handleDeleteSuperMerchant(merchant)} className="p-1 rounded-full text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30" title="Delete" data-id="element-865">
                <TrashIcon className="h-5 w-5" data-id="element-866" />
              </button>
            </div>} data-id="element-859" />
      </Card>

      {/* View Super Merchant Modal */}
      <Modal isOpen={showViewModal} onClose={() => setShowViewModal(false)} title="Super Merchant Details" size="xl" data-id="element-867">
        {selectedSuperMerchant && <div className="space-y-6" data-id="element-868">
            <div className="flex items-center" data-id="element-869">
              <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-800 mr-4" data-id="element-870">
                <BuildingIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" data-id="element-871" />
              </div>
              <div data-id="element-872">
                <h3 className="text-lg font-medium" data-id="element-873">
                  {selectedSuperMerchant.name}
                </h3>
                <div className="flex items-center mt-1" data-id="element-874">
                  {getStatusBadge(selectedSuperMerchant.status)}
                  <span className="mx-2 text-gray-500 dark:text-gray-400" data-id="element-875">
                    •
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-876">
                    {selectedSuperMerchant.businessType}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-877">
              <div data-id="element-878">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" data-id="element-879">
                  Super Merchant Information
                </h4>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2" data-id="element-880">
                  <div className="flex justify-between" data-id="element-881">
                    <span className="text-sm font-medium" data-id="element-882">ID:</span>
                    <span className="text-sm" data-id="element-883">{selectedSuperMerchant.id}</span>
                  </div>
                  <div className="flex justify-between" data-id="element-884">
                    <span className="text-sm font-medium" data-id="element-885">Tax ID:</span>
                    <span className="text-sm" data-id="element-886">
                      {selectedSuperMerchant.taxId}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-887">
                    <span className="text-sm font-medium" data-id="element-888">Merchant Count:</span>
                    <span className="text-sm" data-id="element-889">
                      {selectedSuperMerchant.merchantCount}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-890">
                    <span className="text-sm font-medium" data-id="element-891">
                      Transaction Volume:
                    </span>
                    <span className="text-sm" data-id="element-892">
                      {formatCurrency(selectedSuperMerchant.transactionVolume)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-893">
                    <span className="text-sm font-medium" data-id="element-894">Last Activity:</span>
                    <span className="text-sm" data-id="element-895">
                      {formatDateTime(selectedSuperMerchant.lastActivity)}
                    </span>
                  </div>
                </div>
              </div>
              <div data-id="element-896">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" data-id="element-897">
                  Contact Information
                </h4>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2" data-id="element-898">
                  <div className="flex justify-between" data-id="element-899">
                    <span className="text-sm font-medium" data-id="element-900">Contact Person:</span>
                    <span className="text-sm" data-id="element-901">
                      {selectedSuperMerchant.contactPerson}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-902">
                    <span className="text-sm font-medium" data-id="element-903">Email:</span>
                    <span className="text-sm" data-id="element-904">
                      {selectedSuperMerchant.email}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-905">
                    <span className="text-sm font-medium" data-id="element-906">Phone:</span>
                    <span className="text-sm" data-id="element-907">
                      {selectedSuperMerchant.phone}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-908">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" data-id="element-909">
                Payment Methods
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-910">
                {selectedSuperMerchant.paymentMethods.map(method => <span key={method} className="px-3 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-full text-xs font-medium" data-id="element-911">
                    {method}
                  </span>)}
              </div>
            </div>
            <div data-id="element-912">
              <div className="flex justify-between items-center mb-3" data-id="element-913">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-914">
                  Subordinate Merchants
                </h4>
                <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline" data-id="element-915">
                  View All
                </button>
              </div>
              <div className="bg-gray-50 dark:bg-gray-800 rounded-lg overflow-hidden" data-id="element-916">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-917">
                  <thead className="bg-gray-100 dark:bg-gray-700" data-id="element-918">
                    <tr data-id="element-919">
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-920">
                        Merchant
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-921">
                        Type
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-922">
                        Status
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-923">
                        Stores
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-924">
                        Volume
                      </th>
                      <th scope="col" className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-925">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-926">
                    {subordinateMerchantsData[selectedSuperMerchant.id]?.map(merchant => <tr key={merchant.id} className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-927">
                          <td className="px-4 py-3 whitespace-nowrap" data-id="element-928">
                            <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-929">
                              {merchant.name}
                            </div>
                            <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-930">
                              {merchant.id}
                            </div>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-931">
                            {merchant.type}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap" data-id="element-932">
                            {getStatusBadge(merchant.status)}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-933">
                            {merchant.storeCount}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-934">
                            {formatCurrency(merchant.transactionVolume)}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium" data-id="element-935">
                            <button onClick={() => handleViewSubordinateMerchants(merchant.id, merchant.type)} className="text-blue-600 dark:text-blue-400 hover:text-blue-900 dark:hover:text-blue-300" data-id="element-936">
                              View
                            </button>
                          </td>
                        </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Add/Edit Super Merchant Modal */}
      <Modal isOpen={showAddEditModal} onClose={() => setShowAddEditModal(false)} title={isEditing ? 'Edit Super Merchant' : 'Add Super Merchant'} size="lg" footer={<>
            <button onClick={() => setShowAddEditModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-938">
              Cancel
            </button>
            <button onClick={handleSubmitForm} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-939">
              {isEditing ? 'Update' : 'Add'} Super Merchant
            </button>
          </>} data-id="element-937">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-940">
          <div className="md:col-span-2" data-id="element-941">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-942">
              Super Merchant Name <span className="text-red-500" data-id="element-943">*</span>
            </label>
            <input type="text" name="name" value={formData.name || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter super merchant name" required data-id="element-944" />
          </div>
          <div data-id="element-945">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-946">
              Business Type <span className="text-red-500" data-id="element-947">*</span>
            </label>
            <select name="businessType" value={formData.businessType || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" required data-id="element-948">
              <option value="" data-id="element-949">Select Business Type</option>
              <option value="Retail Conglomerate" data-id="element-950">Retail Conglomerate</option>
              <option value="Food & Beverage" data-id="element-951">Food & Beverage</option>
              <option value="Technology" data-id="element-952">Technology</option>
              <option value="Hospitality" data-id="element-953">Hospitality</option>
              <option value="Transportation" data-id="element-954">Transportation</option>
              <option value="Healthcare" data-id="element-955">Healthcare</option>
              <option value="Education" data-id="element-956">Education</option>
              <option value="Entertainment" data-id="element-957">Entertainment</option>
            </select>
          </div>
          <div data-id="element-958">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-959">
              Tax ID <span className="text-red-500" data-id="element-960">*</span>
            </label>
            <input type="text" name="taxId" value={formData.taxId || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter tax ID" required data-id="element-961" />
          </div>
          <div data-id="element-962">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-963">
              Contact Person <span className="text-red-500" data-id="element-964">*</span>
            </label>
            <input type="text" name="contactPerson" value={formData.contactPerson || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter contact person name" required data-id="element-965" />
          </div>
          <div data-id="element-966">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-967">
              Email <span className="text-red-500" data-id="element-968">*</span>
            </label>
            <input type="email" name="email" value={formData.email || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter email address" required data-id="element-969" />
          </div>
          <div data-id="element-970">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-971">
              Phone <span className="text-red-500" data-id="element-972">*</span>
            </label>
            <input type="tel" name="phone" value={formData.phone || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter phone number" required data-id="element-973" />
          </div>
          <div data-id="element-974">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-975">
              Status
            </label>
            <select name="status" value={formData.status || 'active'} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-976">
              <option value="active" data-id="element-977">Active</option>
              <option value="inactive" data-id="element-978">Inactive</option>
              <option value="pending" data-id="element-979">Pending</option>
            </select>
          </div>
          <div className="md:col-span-2" data-id="element-980">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-981">
              Allowed Payment Methods
            </label>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-id="element-982">
              {['POS', 'QR', 'Online', 'NFC', 'RTP'].map(method => <div key={method} className="flex items-center" data-id="element-983">
                  <input type="checkbox" id={`payment-${method}`} checked={(formData.paymentMethods || []).includes(method)} onChange={() => handlePaymentMethodChange(method)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-984" />
                  <label htmlFor={`payment-${method}`} className="ml-2 block text-sm text-gray-700 dark:text-gray-300" data-id="element-985">
                    {method}
                  </label>
                </div>)}
            </div>
          </div>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)} title="Confirm Deletion" footer={<>
            <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-987">
              Cancel
            </button>
            <button onClick={confirmDelete} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-988">
              Delete
            </button>
          </>} data-id="element-986">
        <div className="space-y-4" data-id="element-989">
          <p className="text-gray-700 dark:text-gray-300" data-id="element-990">
            Are you sure you want to delete the super merchant "
            {selectedSuperMerchant?.name}"? This action cannot be undone.
          </p>
          {selectedSuperMerchant && subordinateMerchantsData[selectedSuperMerchant.id]?.length > 0 && <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md p-3 text-sm text-yellow-800 dark:text-yellow-300" data-id="element-991">
                <p className="font-medium" data-id="element-992">
                  Warning: This super merchant has subordinate merchants
                </p>
                <p className="mt-1" data-id="element-993">
                  Deleting this super merchant will remove all associations with
                  its subordinate merchants. The subordinate merchants will not
                  be deleted but will become unassigned.
                </p>
              </div>}
        </div>
      </Modal>
    </div>;
};
export default AggregatorManagement;